import { combineReducers } from '@reduxjs/toolkit';

import consoleApiSlice from './slices/consoleApiSlice';
import appReducer from './slices/appSlice';

const rootReducer = combineReducers({
  app: appReducer,
  [consoleApiSlice.reducerPath]: consoleApiSlice.reducer,
});

// Add all rtk-middlewares here
export const rootMiddleware = [consoleApiSlice.middleware];

export default rootReducer;
